import type { NextPage } from 'next';
import Link from 'next/link';
import styles from './button1.module.scss';
import { Button1Type } from '@/types/jetCard.types';

const Button1: NextPage<Button1Type> = ({
  className = '',
  text = 'More details',
  onClick,
  href,
}) => {
  const buttonContent = <span className={styles.button}>{text}</span>;

  if (href) {
    return (
      <Link href={href} className={[styles.root, className].join(' ')}>
        {buttonContent}
      </Link>
    );
  }

  return (
    <button className={[styles.root, className].join(' ')} onClick={onClick}>
      {buttonContent}
    </button>
  );
};

export default Button1;
